


















































































// Vue
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'

// services
import { AssistanceService } from '@/services/assistance'

// Models
import { Paginator } from '@/models'
import { AssistanceModel, FiltersAssistance } from '@/models/assistance'

@Component({
    name: 'TableListAsistances',
    components: {
        DataTable
    }
})
export default class TableListAsistances extends Vue {
    @Prop({ type: Object, required: true }) filters!: FiltersAssistance
    loading = false
    filtersChanged = false
    items: AssistanceModel[] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'employee.name',
            sortable: true,
            label: 'Empleado',
            thClass: 'one-line'
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha',
            thClass: 'one-line'
        },
        {
            key: 'checkin_time',
            sortable: true,
            label: 'Hora de Inicio',
            thClass: 'one-line'
        },
        {
            key: 'checkout_time',
            sortable: true,
            label: 'Hora de Salida',
            thClass: 'one-line'
        },
        {
            key: 'absence',
            sortable: true,
            label: 'Inasistencia',
            thClass: 'one-line'
        },
        {
            key: 'reason_absence',
            sortable: true,
            label: 'Motivo',
            thClass: 'one-line'
        },
        {
            key: 'userCreation.name',
            sortable: true,
            label: 'Creado por',
            thClass: 'one-line'
        },
        {
            key: 'type',
            sortable: true,
            label: 'Tipo de Reg.',
            thClass: 'one-line'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '10%'
            }
        }
    ]

    created () {
        this.getAssistancesWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getAssistancesWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getAssistancesWithPagination()
    }

    async getAssistancesWithPagination () {
        this.loading = true
        const { dateStart, dateEnd, employeeId, headquartersId, areaId, subareaId } = this.filters
        if (this.filtersChanged) {
            this.pagination.currentPage = 1
        }
        const response = await AssistanceService.getWithPagination(
            this.pagination.perPage,
            this.pagination.currentPage,
            {
                employeeId: employeeId || null,
                dateStart: dateStart || null,
                dateEnd: dateEnd || null,
                headquartersId: headquartersId || null,
                areaId: areaId || null,
                subareaId: subareaId || null
            }
        )
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
        this.filtersChanged = false
    }

    @Watch('filters', { immediate: true, deep: true })
    changeFilters () {
        this.filtersChanged = true
    }
}
